enum Sex {
  male = "male",
  female = "female"
}

export default Sex;